export const phoneRegExp = /^\+?[0-9]{7,15}$/;
